import { message } from "antd";
import Axios from "axios";
import {
  SET_RIVILE_BIG_BOX_DATA,
  SET_RIVILE_BIG_BOX,
  LOADING_RIVILE_BIG_BOX,
  LOADING_RIVILE_BIG_BOX_DATA,
} from "./../types";

const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

export const getRivileBigBoxItems = (page,perPage ,filter) => async (dispatch) => {
  dispatch(setRivileBigBoxLoadingData());
  try {
    const { data } = await Axios.get(
      `/api/v1/rivile_requests_documents?page=${page}&per_page=${perPage}${filter}`
    );
    dispatch({
      type: SET_RIVILE_BIG_BOX_DATA,
      payload: { data: data.data, totals: data.totals },
    });
  } catch (e) {
    console.log("Error: ", e);
  }
};

export const getRivileBigBoxItem = (id) => async (dispatch) => {
  dispatch(setRivileBigBoxLoading());
  try {
    const { data } = await Axios.get(
      `/api/v1/rivile_requests/requests_by_document/${id}`
    );
    if (data.data) {
      // const dataSorted = data.sort((a,b) => +a.rivile_code - +b.rivile_code)
      dispatch({
        type: SET_RIVILE_BIG_BOX,
        payload: {
          data: data.data,
          show_id: { id: id, created_at: data.main.created_at },
        },
      });
    }
  } catch (e) {
    console.log("Error: ", e);
  }
};

export const updateRivileBBSockets = (data) => async (dispatch, getState) => {
  if(data.deleted_at) {
    return
  }
  const state = getState();
  const { bigbox, show_id } = state.bigbox;
  const findItem = bigbox.find((e) => e.id === data.id);
  if (findItem) {
    // console.log(findItem.identifier , data.identifier, findItem.identifier !== data.identifier)
    if (findItem.identifier !== data.identifier) {
      // console.log('Praejo')
      const bigBoxMap = bigbox.map((e) =>
        e.id === data.id ? { ...data, dublicate: !!e.dublicate } : { ...e }
      );
      // return
      dispatch({
        type: SET_RIVILE_BIG_BOX,
        payload: {
          data: bigBoxMap,
          show_id,
        },
      });
    } 
  }
};

export const addRivileBB = (id, itemObj) => async (dispatch, getState) => {
  const state = getState();
  const { bigbox, show_id } = state.bigbox;
  let bigBoxArr = [...bigbox];
  const findIndex = bigBoxArr.findIndex((e) => e.id == id);
  const item = { ...itemObj, rivile_requests_document_id: show_id.id };

  delete item.created_at;
  delete item.updated_at;
  delete item.id;
  delete item.rivile_boolean;

  try {
    const { data } = await Axios.post(`/api/v1/rivile_requests`, {
      rivile_request: item,
    });

    let newItem = { ...data };
    newItem.dublicate = true;
    newItem.rivile_boolean = !!newItem.rivile_code;
    bigBoxArr.splice(findIndex + 1, 0, newItem);

    dispatch({
      type: SET_RIVILE_BIG_BOX,
      payload: {
        data: bigBoxArr,
        show_id,
      },
    });

    message.success("Sėkmingai pridėta");
  } catch (e) {
    console.log("Error: ", e);
    message.error("Error occurred");
  }
};

export const removeRivileBB = (id) => async (dispatch) => {
  try {
    await Axios.delete(`/api/v1/rivile_requests/${id}`);
    dispatch({
      type: "REMOVE_RIVILE_BB",
      payload: id,
    });
    message.success("Sėkmingai pridėta");
  } catch (e) {
    console.log("Error: ", e);
    message.error("Error occurred");
  }

  // .then((res) => {
  //   if (res.data) {
  //     setBigBoxArr(oldArr.filter((e) => e.id !== id));

  //     message.success("Sėkmingai pridėta");
  //   } else {
  //     message.error("Error occurred");
  //   }
  // });
};

export const getRivileBigBoxItemsFromImport = (data) => async (
  dispatch,
  getState
) => {
  const getStateData = getState();
  const bigboxs = [data, ...getStateData.bigbox.bigboxs];
  const totals = getStateData.bigbox.totals + 1;
  dispatch({
    type: SET_RIVILE_BIG_BOX_DATA,
    payload: { data: bigboxs, totals },
  });
};

export const setRivileBigBoxLoadingData = () => {
  return {
    type: LOADING_RIVILE_BIG_BOX_DATA,
  };
};
export const setRivileBigBoxLoading = () => {
  return {
    type: LOADING_RIVILE_BIG_BOX,
  };
};
